@let activeCampaign = activeCampaign$ | async;
@if(!rewardSystemError()){

  @if(activeCampaign){
    <div class="campaign-banner-container">
      <div class="img-container">
        @if(campaginPicture(); as campaignImg){
          <img [src]="campaignImg.full" [alt]="campaignImg.alt" width="360px" height="94px">
        } @else {
          <img src="assets/images/active-campaign-img.png" role="presentation" width="360px" height="94px">
        }
        <div class="campaign-name-container">
          <span>{{ activeCampaign.textFields | getTranslation:'title' }}</span>
        </div>
      </div>
      <div class="campaign-banner-body">
        <div class="info-text">
          <div class="status">
            <div class="dot"
            [class]="{
              'status-active' : campaignStatus() === E_CAMPAIGN_STATUS.ACTIVE,
              'status-soon' : campaignStatus() === E_CAMPAIGN_STATUS.COMING_SOON,
              'status-ended': campaignStatus() === E_CAMPAIGN_STATUS.ENDED
            }"></div>
            @if(activeCampaign){
              @if(campaignStatus() === E_CAMPAIGN_STATUS.ACTIVE){
                <span>
                    {{ 'Rewards.CAMPAIGN_VALIDITY_DATES' | translate:{ from: activeCampaign.campaignStarts | date:'dd/MM/yyyy', to: activeCampaign.campaignEnds | date:'dd/MM/yyyy' } }}
                </span>
              } @else if(campaignStatus() === E_CAMPAIGN_STATUS.COMING_SOON){
                <span>
                    {{ 'Rewards.COMING_SOON_ON' | translate:{ date: activeCampaign.campaignStarts | date:'dd/MM/yyyy' } }}
                </span>
              }
            }
          </div>
          <div class="text">
            <h3>{{'Rewards.CAMPAIGN_BANNER_TITLE' | translate }}</h3>
            <span>{{'Rewards.CAMPAIGN_BANNER_BODY' | translate }}</span>
          </div>
        </div>
        <a [ariaDisabled]="!campaingInfo()" [routerLink]="[campaignDetailsLink]" (click)="linkClicked.emit()" class="go-to-campaing-details" >{{'Rewards.CAMPAIGN_BANNER_BUTTON' | translate}}</a>
      </div>
    </div>

  }


} @else {
  <wallet-list-error
    [componentType]="'CAMPAIGN'"
  ></wallet-list-error>
}
